import axios from "axios";
import APP from "../main";
import Cookie from "js-cookie";
import { GetAuthToken } from "rj-server-auth-token";
import {
  handleAxiosAndRouterToken,
  PARTNERS_TOKEN,
  removeAllCookie,
  toLogin,
} from "../libs/loginUtils";
// 接口白名单
const whiteList = ["/partners-center-admin/userAuthority/token/generate"];
let querystring = require("querystring");
// 允许跨域请求发送cookie
// axios.defaults.withCredentials = true;
axios.defaults.baseURL = window._env_.BASE_API;
axios.defaults.headers.post["Content-Type"] = "application/json"; // application/x-www-form-urlencoded , multipart/form-data
// http请求拦截
axios.interceptors.request.use(
  async (config) => {
    if (!whiteList.includes(config.url)) {
      await handleAxiosAndRouterToken();
      // 这个地方的时候必有token
      config.headers["token"] = Cookie.get(PARTNERS_TOKEN);
    }
    // config.withCredentials = true; // 开启携带cookie
    if (
      config.headers["Content-Type"] === "application/x-www-form-urlencoded"
    ) {
      config.data = querystring.stringify(config.data);
    }
    config.headers.sysId = window._env_.SYS_ID;
    config.headers["web-sign-server-auth"] = GetAuthToken({
      sysId: window._env_.SYS_ID,
      accessKeySecret: window._env_.ACCESS_KEY_SECRET,
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  (res) => {
    let json = res.data;
    if (json && json.status !== "200" && json.status) {
      if (json.status === "88888") {
        window.location.href =
          "https://www.ruijie.com/login.aspx?r=" +
          encodeURIComponent(window.location.href);
      } else if (json.status === "403") {
        window.location.href = "/403";
      } else {
        APP.$message({
          message: json.err,
          type: "error",
        });
      }
    }
    return res;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      localStorage.removeItem("userInfo");
      removeAllCookie();
      toLogin();
    }
    APP.$message({
      message: "请求异常",
      type: "error",
    });
    return Promise.reject(error);
  }
);
// axios 具体使用 请参考 https://github.com/axios/axios
export default {
  axios: axios,
  // FORM_HEADER: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
  getAllCountries: (language) =>
    axios.get("area/getAllCountries?language=" + language), // 获取所有国家
  getAllSteps: (language) =>
    axios.get("sysFlowStepInfo/getSysFlowStepInfo?language=" + language), // 获取所有审核节点，用于列表查询
  getProBaseInfo: (objectId, language) =>
    axios.get(
      "prm/baseinfo/view?objectId=" + objectId + "&language=" + language
    ), // 获取项目报备信息，用于预览
  getPrmBaseInfo: (objectId, language) =>
    axios.get(
      "/currency/prm/baseinfo/view?objectId=" +
        objectId +
        "&language=" +
        language
    ), // 获取项目报备信息，用于预览
  getFlowLogs: (objectId, language) =>
    axios.get("prm/flow/logs?objectId=" + objectId + "&language=" + language), // 获取审核日志
  currentFlowtempl: (objectId, language) =>
    axios.get(
      "prm/flow/templates?objectId=" + objectId + "&language=" + language
    ), // 获取审核节点模板，用于顶部审批图形
  currentFlow: (objectId) =>
    axios.get("prm/flow/currentStep?objectId=" + objectId), // 获取当前审核节点，用于顶部审批图形
  salesAudit: (params) => axios.post("prm/flow/salesAudit", params), // 审批操作
  discard: (objectId, reason) =>
    axios.post("prm/discard?reason=" + reason + "&objectId=" + objectId), // 废弃
  getList: (params) => axios.post("prm/list", params), // 获取列表
  getProjectStep: (language) =>
    axios.get("/base/getBasePhaseDataList?language=" + language), // 获取项目步骤
  getTodoList: (params) => axios.post("/currency/prm/list/todo", params), // 获取待办列表
  getLeftMenuData: (language) =>
    axios.get("menu/getMenus?language=" + language), // 获取左侧目录
  getDrafts: (params) => axios.post("prm/getDraftList", params), // 获取草稿列表
  deleteDraft: (objectId) => axios.post("prm/deleteDraft", objectId), // 删除某个草稿
  getCurUser: () => axios.post("user/curUser"), // 获取当前登录用户
  savePrmDraft: (body) => axios.post("prm/saveDraft", body), // 保存报备信息到草稿箱
  submitPrm: (body) => axios.post("prm/apply", body), // 提交项目报备申请
  getPrmSelectData: (language) =>
    axios.get("base/getBaseConfig?language=" + language), // 获取下拉列表数据源
  backdoor: (uid) => axios.get("devEnvLogin?userId=" + uid), // 后门登录
  getAttachmentById: (objectId, type) =>
    axios.get("attachment/" + objectId + "/" + type), // 根据业务id查询附件
  getByMasterAccount: (userId) =>
    axios.get(
      "/partners-customer-service/users/getByMasterAccount?masterAccount=" +
        userId,
      { baseURL: window._env_.BASE_APIS }
    ), // 获取RAP
  getIsEditUsers: () =>
    axios.get("/partners-customer-service/users/isEditUser", {
      baseURL: window._env_.BASE_APIS,
    }), // 获取角色如超管
  getSaleByArea: (areaCode) =>
    axios.get("area/getSaleByArea?areaCode=" + areaCode), // 根据区域查询销售
  updatePrmBaseInfo: (body) => axios.put("prm/update", body), // 编辑项目报备
  getCurUserRole: () => axios.post("user/getIsChannelRole"), // 获取当前登录用户是否是渠道
  // getOperationLogs: (params) => axios.get('prm/baseinfo/operationLogs', params), // 获取项目报备操作日志
  getOperationLogs: (params) =>
    axios.get("/prm/baseinfo/operationHistory", params), // 获取项目报备操作日志
  readAndAgreeClause: (params) => axios.post("user/readAndAgreeClause", params), // 阅读并同意报备条款
  getUserList: (keyword) => axios.get("user/list?keyword=" + keyword), // 根据输入内容查询用户列表
  queryProjectNoRestriction: (params) => axios.post("prm/list/noRes", params), // 对所有用户开放的根据项目名称和最终用户姓名查询项目
  getPartnerDetail: () => axios.get("prm/partner/detail"), // 对所有用户开放的根据项目名称和最终用户姓名查询项目
  checkRiskLevel: (body) => axios.post("prm/checkRiskLevel", body), // 校验出口管制限制等级
  postOssUpload: (params) => axios.post(`/common/upload`, params), // 上传附件信息
  productFile: (params) =>
    axios.get(`/prm/export?query=` + params, { responseType: "blob" }), // 导出
  productExport: (body) =>
    axios.post("/ProBaseProduct/productExport", body, { responseType: "blob" }), // 导出
  postGenerate: (params) =>
    axios.post(`/partners-center-admin/userAuthority/token/generate`, params, {
      baseURL: window._env_.BASE_APIS,
    }), // 获取用户token
  getSwitchAccountCookie: (userId) =>
    axios.get(
      `/partners-center-admin/account/account/switchAccountReturnToken?userId=${userId}`,
      { baseURL: window._env_.BASE_APIS }
    ), // 切换用户
  getDepartments: () =>
    axios.post(`/partners-customer-service/partnerTypes/getDeptByUser`, null, {
      baseURL: window._env_.BASE_APIS,
    }), // 获取部门
  getTwoPartnerListL: (currentCompanyCode, companyName) =>
    axios.get(
      `partners-customer-service/partner/getTwoPartnerLists?currentCompanyCode=` +
        currentCompanyCode +
        "&companyName=" +
        companyName,
      { baseURL: window._env_.BASE_APIS }
    ), // 获取RelatedPartnerName下拉
  getUserBtnPermissions: () =>
    axios.get(
      `/partners-center-admin/userAuthority/authority/get-user-btn-permissions`,
      { baseURL: window._env_.BASE_APIS }
    ),
  getAllCurrency: () => axios.post("/prm/allCurrency"), // 获取全部币种
  proBaseProductProductUpload: (file) =>
    axios.post("/ProBaseProduct/productUpload", file, {
      headers: { "Content-Type": "multipart/form-data" },
    }), // 导入产品信息
  getSelectByProductName: (productName) =>
    axios.get(`/ProBaseProduct/selectByProductName?productName=` + productName), // 名称查询产品信息
  productExportTemplate: (body) =>
    axios.post("ProBaseProduct/productExportTemplate", body, {
      responseType: "blob",
    }),
};
